import axios from "axios";
import config from '../../config';

// Action Types
export const FETCH_CURRENT_YEAR_PAID_REQUEST = "FETCH_CURRENT_YEAR_PAID_REQUEST";
export const FETCH_CURRENT_YEAR_PAID_SUCCESS = "FETCH_CURRENT_YEAR_PAID_SUCCESS";
export const FETCH_CURRENT_YEAR_PAID_FAILURE = "FETCH_CURRENT_YEAR_PAID_FAILURE";

// Action Creators
export const fetchCurrentYearPaidRequest = () => ({
  type: FETCH_CURRENT_YEAR_PAID_REQUEST,
});

export const fetchCurrentYearPaidSuccess = (paidList) => ({
  type: FETCH_CURRENT_YEAR_PAID_SUCCESS,
  payload: paidList,
});

export const fetchCurrentYearPaidFailure = (error) => ({
  type: FETCH_CURRENT_YEAR_PAID_FAILURE,
  payload: error,
});

// Thunk to Fetch Data
export const fetchCurrentYearPaidList = () => async (dispatch) => {
  dispatch(fetchCurrentYearPaidRequest());
  try {
    const response = await axios.get(`${config.apiBaseUrl}/payments/currentYearBalance.php`);
    dispatch(fetchCurrentYearPaidSuccess(response.data));
  } catch (error) {
    dispatch(fetchCurrentYearPaidFailure(error.message));
  }
};
